import React, { useId } from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

const ZoneContainer = styled.div`
  width: 100%;
  overflow: hidden;
  position: relative;
  opacity: 0.5;
`;

const ScrollTrack = styled.div`
  display: flex;
  width: fit-content;
`;

const ScrollSection = styled(motion.div)`
  display: flex;
  align-items: center;
  gap: 40px;
  padding: 0 20px;
`;

const LogoWrapper = styled.div`
  height: ${props => props.mobile ? '40px' : '60px'};
  .gatsby-image-wrapper {
    height: 100%;
    width: max-content!important;
    img {
      height: 100% !important;
      object-fit: contain !important;
    }
  }
`;

const UniversityEndlessScroll = ({ isConsideredMobile }) => {
  const data = useStaticQuery(graphql`
    query {
      allFile(
        filter: {
          sourceInstanceName: { eq: "images" }
          relativePath: { regex: "/^propy-academic-/" }
        }
        sort: { fields: relativePath }
      ) {
        edges {
          node {
            relativePath
            childImageSharp {
              gatsbyImageData(
                height: 60
                transformOptions: {
                  fit: CONTAIN
                }
                placeholder: BLURRED
                layout: CONSTRAINED
                quality: 100
              )
            }
          }
        }
      }
    }
  `);

  const universityLogos = data.allFile.edges.map(({ node }) => getImage(node));
  const componentId = useId();
  
  return (
    <ZoneContainer>
      <ScrollTrack>
        {[0, 1, 2].map((i) => (
          <ScrollSection
            key={`${componentId}-${i}`}
            initial={{ x: 0 }}
            animate={{ 
              x: [0, -100 + '%']
            }}
            transition={{
              x: {
                repeat: Infinity,
                repeatType: "loop",
                duration: 20,
                ease: "linear",
              },
            }}
          >
            {universityLogos.map((logo, index) => (
              <LogoWrapper
                key={`${componentId}-${i}-${index}`}
                mobile={isConsideredMobile}
              >
                <GatsbyImage
                  image={logo}
                  alt={`University Logo ${index + 1}`}
                  style={{
                    height: '100%',
                    width: 'auto'
                  }}
                  imgStyle={{
                    objectFit: 'contain',
                  }}
                />
              </LogoWrapper>
            ))}
          </ScrollSection>
        ))}
      </ScrollTrack>
    </ZoneContainer>
  );
};

export default UniversityEndlessScroll;